module.exports = __webpack_public_path__ + "media/images/lane/header-tablet-24335fafbf1cfcf1c28a07fc4238212e.svg";